<template>
  <div id="app">
    <div id="splashScreen" v-show="!isCompeted">
        <div class="loading"></div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import JParticles from 'JParticles/production/jparticles';
import 'JParticles/production/wave_loading';

export default {
  name: 'app',
  data(){
    return {
        isCompeted: false
      }
  },
  mounted(){    

    var self = this;

    // 扩展 easing 函数
    JParticles.utils.extend(JParticles.easing, {
        easeOutBounce: function (x, t, b, c, d) {
            if ((t/=d) < (1/2.75)) {
                return c*(7.5625*t*t) + b;
            } else if (t < (2/2.75)) {
                return c*(7.5625*(t-=(1.5/2.75))*t + .75) + b;
            } else if (t < (2.5/2.75)) {
                return c*(7.5625*(t-=(2.25/2.75))*t + .9375) + b;
            } else {
                return c*(7.5625*(t-=(2.625/2.75))*t + .984375) + b;
            }
        }
    });

    var instance = document.querySelector('#splashScreen .loading');
    var loading = new JParticles.waveLoading(instance, {
        font: 'normal 900 16px Arial',
        resize: true,

        // 换一种 easing 动画效果
        easing: 'easeOutBounce'
    });

    loading
        .onProgress(function (progress) {
            if (progress >= 60) {
                loading.setOptions({
                    color: '#fff'
                });
            }
            return '加载中...' + Math.ceil(progress) + '%';
        })
        .onFinished(function () {

            // 加载完成后，隐藏遮罩及 loading 动画。
            // 开一个 50ms 的定时器，为了让 100% 这几个字能被看见。
            setTimeout(function () {
                //instance.parentNode.removeChild(instance);
                self.isCompeted = true;
            }, 50);
        });

      window.onload = function(){
        loading.done();
      }
  }
}
</script>

<style>

html,body {
  position: relative;
  width: 100%;
  height: 100%;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}

#splashScreen {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999;
    background: #fff;
}

#splashScreen .loading{
    display: inline-block;
    width: 120px;
    height: 120px;
    margin: -60px 0 0 -60px;
    border-radius: 50%;
    border-color: #ececec;
    position: absolute;
    top: 50%;
}

</style>



// WEBPACK FOOTER //
// App.vue?a393500a